const Info = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 4.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15M3.5 12a8.5 8.5 0 1 1 17 0 8.5 8.5 0 0 1-17 0"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M11.5 11.5a.5.5 0 0 1 1 0v4a.5.5 0 0 1-1 0zM12.75 8.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"
    />
  </>
)
export default Info
